import React from 'react';
import { FiStar, FiCheckCircle, FiAlertTriangle } from 'react-icons/fi';
import { useProductKlasse } from '../contexts/ProductKlasseContext';
import './ProductKlasseIcon.css';

export const PRODUCT_KLASSE_META = {
  top: { Icon: FiStar, color: '#0d9488', label: 'Topproduct' },
  prima: { Icon: FiCheckCircle, color: '#64748b', label: 'Prima product' },
  matig: { Icon: FiAlertTriangle, color: '#dc2626', label: 'Matig product (uitfaseer-kandidaat)' },
};

export function resolveProductKlasse(productId, klasseProp, map) {
  if (klasseProp && PRODUCT_KLASSE_META[klasseProp]) return klasseProp;
  if (productId != null && map && map[productId]) return map[productId];
  if (productId != null && map && map[String(productId)]) return map[String(productId)];
  return null;
}

export default function ProductKlasseIcon({ productId, klasse: klasseProp, size = 14, className = '' }) {
  const { map } = useProductKlasse();
  const klasse = resolveProductKlasse(productId, klasseProp, map);
  if (!klasse || !PRODUCT_KLASSE_META[klasse]) return null;

  const { Icon, color, label } = PRODUCT_KLASSE_META[klasse];
  return (
    <span className={`product-klasse-icon ${className}`.trim()} title={label} aria-label={label}>
      <Icon size={size} color={color} strokeWidth={klasse === 'top' ? 2.5 : 2} />
    </span>
  );
}

export function ProductNaamMetKlasse({
  productId,
  product_id,
  naam,
  children,
  klasse,
  product_klasse,
  className = '',
  strong = false,
  iconSize = 14,
}) {
  const id = productId ?? product_id;
  const label = children ?? naam;
  const Tag = strong ? 'strong' : 'span';
  const klasseVal = klasse ?? product_klasse;

  if (!label) return null;

  return (
    <span className={`product-naam-met-klasse ${className}`.trim()}>
      <ProductKlasseIcon productId={id} klasse={klasseVal} size={iconSize} />
      <Tag>{label}</Tag>
    </span>
  );
}
